export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./personHome.vue?vue&type=template&id=98c90076&"


//////////////////
// WEBPACK FOOTER
// ./src/views/personHome/personHome.vue?vue&type=template&id=98c90076&
// module id = null
// module chunks = 